import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

// Ask-button CSS matches @labrav/common LabraAIChatTriggerButton.styles so the
// Canvas entry point looks the same; sized down slightly to sit on the card
// heading row. Root uses natural height so useCanvasContentResize can measure
// content and drive the native-package LWC iframe height.
export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
  },
  askBtn: {
    background:
      'linear-gradient(114.88deg, rgb(255,112,138) 31.244%, rgb(191,84,142) 53.577%, rgb(115,52,149) 78.991%)',
    borderRadius: 10,
    padding: '6px 12px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    boxShadow: '0px 4px 16px rgba(0,0,0,0.2)',
    transition: 'transform 0.15s ease',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  askIcon: {
    fontSize: 14,
    color: theme.palette.text.white,
  },
  askLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 13,
    color: theme.palette.text.white,
    whiteSpace: 'nowrap',
  },
}))
